/**
 * Converts plain clipboard text into a schema-independent list of inline
 * segments. Empty lines are represented by adjacent hard-break segments.
 */
const getPlainTextPasteSegments = (text) => {
  const segments = [];

  text.replace(/\r\n?/g, '\n').split('\n').forEach((line, index) => {
    if (index > 0) {
      segments.push({ type: 'hardBreak' });
    }

    if (line) {
      segments.push({ type: 'text', text: line });
    }
  });

  return segments;
};

export { getPlainTextPasteSegments };
